import React from 'react';
import {connect} from 'react-redux';
import history from "../../../../libs/history";
import {bindActionCreators} from "redux";
import {PageLoader} from "../../../components/Loader";
import _ from "lodash";
import {fetchCategoriesRoot} from "../../../../creators/categories.rootChildrens";
import createLink from "../../../../libs/createLink";


class SideBar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        };
        if(_.get(this.props,"categoryId")){
            this.props.fetchCategoriesRoot(this.props.categoryId, {sort : "order", categories : this.props.categories, facetteId : this.props.facetteId, facetteAncre : this.props.facetteAncre});
        }
        this.catRef = React.createRef();

    }

    handleCategory(categoryParent,category){
        let categories = this.props.categories;
        if(!categoryParent.isMultipleSelection){
            let categoriesIds = categoryParent.childrens.map(item => item._id.toString());
            categories = categories.filter(item => !categoriesIds.includes(item));
        }
        if(categories.includes(category._id.toString())){
            categories = categories.filter(item => item !== category._id.toString());
        }
        else{
            categories.push(category._id);
        }

        this.props.handleCategories(categories.filter(item => item !==""));
        //console.log(categories);

    }

    componentDidUpdate(prevProps, prevState) {
        if(this.props.categoriesRootInitialized && this.props.categoriesRoot.length){
            if(this.catRef.current){
                this.catRef.current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                })
            }
        }
    }

    gotoUrl(uri){
        uri = uri ? createLink('facette', {slug : uri}) : false;
        if(uri){
            //window.location.href=uri;
            history.push(uri);
        }
    }

    render() {
        return !this.props.categoriesRootInitialized ? (
            <div className={"sidebar"}>
                <PageLoader/>
            </div>
        ) :
            (
            <div className={"sidebar"}>
                {this.props.categoriesRoot.map(category =>(
                    <fieldset key={category._id} className={"card categories"}>
                        <h4>{category.title}</h4>
                        <ul>
                            {category.childrens && category.childrens.map((subCategory, index)=> (
                                <li key={subCategory._id} className={"row"} ref={category.slug !== "media" && category.slug !== "genre" && this.props.categories.includes(subCategory._id.toString()) ? this.catRef : null} >
                                    {/*category.isMultipleSelection ?
                                    <input
                                        type={"checkbox"}
                                        className={"input-category"}
                                        checked={this.props.categories.includes(subCategory._id.toString())}
                                        onChange={() =>this.gotoUrl(subCategory.uri)}
                                        value={subCategory._id}
                                    /> : <RadioInputField
                                            className={"input-category"}
                                            checked={this.props.categories.includes(subCategory._id.toString())}
                                            onChange={() =>this.gotoUrl(subCategory.uri)}
                                            value={subCategory._id}
                                             />*/}
                                    <input
                                        type={"checkbox"}
                                        className={"input-category"}
                                        checked={this.props.categories.includes(subCategory._id.toString())}
                                        onChange={() =>this.gotoUrl(subCategory.uri)}
                                        value={subCategory._id}
                                    />
                                    <label><a href={subCategory.uri ? createLink('facette', {slug : subCategory.uri}) : null}>{subCategory.title}</a></label>

                                </li>
                            ))}
                        </ul>
                    </fieldset>
                ))}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        categoriesRoot : state.categoriesRoot.data,
        categoriesRootInitialized : state.categoriesRoot.initialized,
        categoriesRootLoading : state.categoriesRoot.loading,

    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchCategoriesRoot,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SideBar);
